<template>
  <div class="image-upload">
    <div class="upload-area" v-if="!value" @click="openPicker">
      <i class="el-icon-plus"></i>
      <span>点击上传</span>
      <input ref="fileInput" type="file" :accept="inputAccept" @change="onFileChange" style="display:none" />
    </div>
    <div class="preview-area" v-else>
      <img v-if="isImage" :src="value" />
      <div v-else class="file-preview">
        <i :class="isAudio?'el-icon-video-pause':'el-icon-video-play'" style="font-size:40px;color:#409EFF"></i>
        <span class="file-name">{{ value.split('/').pop().substring(0,20) }}</span>
      </div>
      <div class="preview-actions">
        <el-button type="text" icon="el-icon-delete" @click="remove">移除</el-button>
        <el-button type="text" icon="el-icon-upload" @click="openPicker">替换</el-button>
      </div>
      <input ref="fileInput" type="file" :accept="inputAccept" @change="onFileChange" style="display:none" />
    </div>
    <div v-if="uploading" class="progress">上传中...</div>
  </div>
</template>

<script>
import api from '../api'
export default {
  props: {
    value: { type: String, default: '' },
    accept: { type: String, default: '' }
  },
  data() { return { uploading: false } },
  computed: {
    inputAccept() {
      var type = String(this.accept || '').toLowerCase()
      if (type === 'image') return 'image/*'
      if (type === 'audio') return 'audio/*,.mp3,.m4a,.wav,.ogg'
      return 'image/*,audio/*,video/*,.mp3,.m4a,.wav,.ogg,.mp4'
    },
    isImage() { var v=this.value||''; return /\.(png|jpg|jpeg|gif|webp|svg)/i.test(v) || !/\.\w+$/.test(v) },
    isAudio() { return /\.(mp3|wav|m4a|ogg)/i.test(this.value||'') }
  },
  methods: {
    openPicker() { this.$refs.fileInput.click() },
    async onFileChange(e) {
      var file = e.target.files[0]; if (!file) return
      this.uploading = true
      try {
        var ext = (file.name || '').split('.').pop() || 'png'
        var tokenRes = await api.getUploadToken({ ext: ext })
        if (tokenRes.data.code !== 0) { this.$message.error('获取凭证失败'); this.uploading = false; return }
        var info = tokenRes.data.data
        var formData = new FormData()
        formData.append('token', info.token); formData.append('key', info.key); formData.append('file', file)
        var uploadRes = await fetch(info.uploadUrl, { method: 'POST', body: formData })
        var result = await uploadRes.json()
        if (result.key) { this.$emit('input', info.domain + '/' + result.key); this.$message.success('上传成功') }
        else { this.$message.error('上传失败: ' + (result.error || '')) }
      } catch (err) { this.$message.error('上传失败') }
      this.uploading = false; this.$refs.fileInput.value = ''
    },
    remove() { this.$emit('input', '') }
  }
}
</script>

<style scoped>
.upload-area { width: 120px; height: 120px; border: 2px dashed #ccc; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; color: #999; gap: 8px; font-size: 14px; }
.upload-area:hover { border-color: #409EFF; color: #409EFF; }
.upload-area i { font-size: 28px; }
.preview-area { position: relative; width: 120px; }
.preview-area img { width: 120px; height: 120px; object-fit: cover; border-radius: 8px; border: 1px solid #eee; }
.file-preview { width: 120px; height: 120px; border: 1px solid #eee; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; background: #f5f7fa; gap: 6px; }
.file-name { font-size: 10px; color: #666; word-break: break-all; text-align: center; padding: 0 4px; }
.preview-actions { position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0,0,0,0.6); display: flex; justify-content: center; border-radius: 0 0 8px 8px; }
.preview-actions .el-button { color: #fff; padding: 4px 8px; font-size: 12px; }
.progress { color: #409EFF; font-size: 13px; margin-top: 4px; }
</style>
